import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast2 extends BCComponent {

    render() {
        return (
            <div>
                <h1>ZÁKLADNÍ VÝDAJE V ROZPOČTU</h1>
                <div className='separate-bottom'>
                    <p>Při domácím hospodaření je dobré pracovat s tzv. rozpočtem domácnosti, u jednotlivce pak  mluvíme o osobním rozpočtu. Rozpočet obsahuje všechny příjmy a výdaje, které (jako domácnost) máme.</p>
                    <p>Nejvíce peněz dávají lidé většinou za jídlo a bydlení. Na rozdíl od výdajů na bydlení, které jsou každý měsíc plus mínus stejné, výdaje na jídlo se mění a je dobré je hlídat, abychom neutratili přespříliš.</p>
                </div>

                { this.showTask("zs_vydaje_1") }
                { this.showTask("zs_vydaje_2") }
                { this.showTask("zs_vydaje_3") }
                { this.showTask("zs_vydaje_4") }
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast2);
